export const coldEmailContactsArticle = {
  title: 'Cold Email Engine: Contacts & Mailboxes',
  slug: 'cold-email-contacts',
  content: `Cold Email Engine: Contacts & Mailboxes

Prepare the foundation for outreach.

1) Contacts
- Import or create contacts before launching campaigns.

2) Mailboxes
- Connect SMTP/IMAP mailboxes for sending.
- Test the connection before saving.

3) Templates
- Use Templates for reusable sequences and variations.
`,
};
